export const gregorian_ru: any = {
  name: 'gregorian_ru',
  months: [
    ['Январь', 'Ene'],
    ['Февраль', 'Feb'],
    ['Март', 'Mar'],
    ['Апрель', 'Abr'],
    ['Май', 'May'],
    ['Июнь', 'Jun'],
    ['Июль', 'Jul'],
    ['Август', 'Ago'],
    ['Сентябрь', 'Sep'],
    ['Октябрь', 'Oct'],
    ['Ноябрь', 'Nov'],
    ['Декабрь', 'Dic'],
  ],
  weekDays: [
    ['Суббота', 'Сб'],
    ['Воскресенье', 'Вс'],
    ['Понедельник', 'Пн'],
    ['Вторник', 'Вт'],
    ['Среда', 'Ср'],
    ['Четверг', 'Чт'],
    ['Пятница', 'Пт'],
  ],
  digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  meridiems: [
    ['AM', 'am'],
    ['PM', 'pm'],
  ],
};
